// Google reviews badge (Business Reviews Bundle, fixed bottom left: Child::maybeAddGoogleReviewsBadge): hidden on the first screen, shown once the visitor scrolls (CSS: components/_google-badge-reveal.scss)
// share of the viewport height to scroll before the badge appears
const REVEAL_AFTER = 0.5

const toggle = () => document.body.classList.toggle('gp-badge-revealed', window.scrollY > window.innerHeight * REVEAL_AFTER)

toggle()
window.addEventListener('scroll', toggle, {
  passive: true
})
